import React, { PropsWithChildren } from 'react'
import { parseErrorMessage } from 'api'
import { createContext } from 'lib/createContext'
import { useAuthorizeAdminMutation } from 'queries/admin/userPermissions'

type AuthorizeAdminFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useAuthorizeAdminMutation>['mutate']
    reset: ReturnType<typeof useAuthorizeAdminMutation>['reset']
  }
}

const [Context, useAuthorizeAdminFlowContextValue] =
  createContext<AuthorizeAdminFlowContextState>({
    name: 'AuthorizeAdminFlowContext',
  })

export const AuthorizeAdminFlowProvider = ({ children }: PropsWithChildren) => {
  const { mutate, reset, isPending, error } = useAuthorizeAdminMutation()

  const value: AuthorizeAdminFlowContextState = {
    state: {
      mutationState: {
        isPending,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useAuthorizeAdminFlowContextValue }
